import { useState } from 'react';

export default function useAuthListener() {
    const [user, setUser] = useState(localStorage.getItem('access_token'));
    // const [user, setUser] = useState(true);

    // useEffect(() => {
    //     const listener = firebase.auth().onAuthStateChanged((authUser) => {
    //         if (authUser) {
    //             localStorage.setItem('authUser', JSON.stringify(authUser));
    //             setUser(authUser);
    //         } else {
    //             localStorage.removeItem('authUser');
    //             setUser(null);
    //         }
    //     });

    //     return () => listener();
    // }, []);

    console.log('useAuthListener user', user)
    return { user };
}
